import axiosapi from "../api/axiosapi";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import useAuth from "../hooks/useAuth";

const GradeList = () => {
    const [grade, setGrade] = useState('');
    const {phaseCode, phaseTitle, phaseDescription} = useLocation().state;
    const [randomString, setRandomString] = useState();
    const {auth, setAuth} = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const fetchGradeList = async () => {
            try {
                const response = await axiosapi.get('/phase/'+phaseCode)
                response.data && setGrade(response.data);
            } catch(err) {
                console.log(err)
            }
            
        }

        fetchGradeList();
    },[phaseCode])

    useEffect(() => {
        const randomAlphabetString = () => {
            const letters = '1234567890';
            let randomStringl = '';
            for (let i = 0; i < 12; i++) {
                randomStringl += letters[Math.floor(Math.random() * letters.length)];
            }
            setRandomString(randomStringl); 
          };
          randomAlphabetString();
    },[grade])
   
    return(
        <div className="vertical-flex-container-1">
            <div className="content-box-1">
                <div className="card-list-title">
                    <h4 style={{color:"sienna", fontWeight:"bold"}}>{phaseTitle}</h4>
                </div>
                <div className="card-container">
                    {/* <div className="containerListItem">
                        <div className="improveAbilityCards"> */}
                            {grade && grade.map( grade => {
                                return(
                                    <div key={grade.subjectCode} className="card">
                                        <h5>{grade.subjectTitle}</h5>
                                        <p>{grade.subjectDescription}</p>
                                        <Link 
                                            to={`/mathsubject/${randomString}` }
                                            state={{
                                                "subjectCode": grade.subjectCode,
                                                "problemCode": grade.firstProblemCode,
                                                "subjectTitle": grade.subjectTitle
                                            }}
                                        >
                                            바로가기
                                        </Link>
                                    </div>
                                )
                            })}
                        {/* </div>
                    </div> */}
                </div>
            </div>
            <div style={{width: "100%"}}>
                <Footer/>
            </div>
        </div>
    )
}

export default GradeList;